<template>
	<div
		v-if="form"
		:class="`${inFrame ? 'outer-wrapper-in-frame' : 'outer-wrapper'} row-format centered`"
		:style="`font-family: ${font}; --background-color: ${form.accentColor}`"
	>
		<v-container :class="`${inFrame ? 'main-wrapper-in-frame' : 'main-wrapper'}`" v-if="form">
			<v-row v-if="form.showLogo && form.accountLogo" class="form-logo-row">
				<v-col cols="12">
					<img class="form-logo" :src="form.accountLogo" />
				</v-col>
			</v-row>
			<v-row v-if="!complete" dense>
				<v-col cols="12">
					<div class="form-fields">
						<renderer ref="renderer" :schema="form.schema" @input="handleResult"></renderer>
					</div>
				</v-col>
				<v-col cols="12">
					<div class="form-footer">
						<v-btn class="form-submit" :color="form.accentColor" elevation="0" @click="saveForm"
							><span
								:style="`font-weight: 600; color: ${form.buttonText}!important; text-transform:none!important`"
								>{{ $t('global.submit') }}</span
							></v-btn
						>
						<div class="form-recaptcha font-gray_70">
							This page is protected by reCAPTCHA and the Google
							<a href="https://policies.google.com/privacy">Privacy Policy</a> and
							<a href="https://policies.google.com/terms">Terms of Service</a> apply.
						</div>
					</div>
				</v-col>
			</v-row>
			<v-row v-else>
				<v-col cols="12">{{ $t('discovery.complete') }}</v-col>
			</v-row>
		</v-container>

		<v-snackbar v-model="showError" top color="gray_80" :timeout="5000">
			{{ errorText }}
			<template v-slot:action="{ attrs }">
				<v-btn color="error" text v-bind="attrs" @click="showError = false"> OK </v-btn>
			</template>
		</v-snackbar>
	</div>
</template>

<script>
  import Renderer from '@/modules/forms/v1/renderer/Renderer';

  export default {
		name: 'FormV1',

		props: ['form', 'font', 'inFrame','complete'],

		components: { Renderer },

		data: function () {
			return {
				result: null,
				showError: false,
				errorText: null,
				showSubmitButton: true,
			};
		},

		mounted() {},

		beforeDestroy() {},

		methods: {
			saveForm: function () {
				if (!this.$refs.renderer.validate()) {
					this.errorText = 'Please correct the errors in your form';
					this.showError = true;
					return false;
				}

				let formResult = {};

				let answers = [];
				let files = [];
				let keys = Object.keys(this.result);

				for (let i = 0; i < keys.length; i++) {
					let id = keys[i];
					let schemaIndex = this.form.schema.findIndex((s) => s.id === keys[i]);
					let schemaItem = this.form.schema.find((s) => s.id === keys[i]);

					if (schemaItem.fieldType === 'LeadContact') {
						let contactInfo = this.result[keys[i]];
						Object.keys(contactInfo).forEach((p) => {
							if (contactInfo[p]) {
								formResult[p] = contactInfo[p];
							}
						});
					} else {
						let answer;
						let question = schemaItem.htmlText;

						if (schemaItem.fieldType === 'FileInput') {
							let fileResult = this.result[keys[i]];
							files.push(...fileResult);
							answer = JSON.stringify(files.map((f) => f.name));
						} else if (Array.isArray(this.result[keys[i]])) {
							answer = this.result[keys[i]].join(',');
						} else {
							answer = this.result[keys[i]];
						}

						answers.push({
							index: schemaIndex,
							id: id,
							question: question,
							answer: answer,
							fieldKey: schemaItem.fieldKey,
							fieldType: schemaItem.fieldType,
						});
					}
				}

				answers.sort((a, b) => a.index - b.index);
				formResult.answers = answers;

				this.$emit('complete', {
					formResult: formResult,
					files: files,
				});
			},

			handleResult: function (result) {
				this.result = result;
			},
		},

		computed: {},
	};
</script>

<style scoped lang="scss">
	.outer-wrapper {
		background:
			radial-gradient(circle at 15% 10%, color-mix(in srgb, var(--background-color) 8%, transparent), transparent 34%),
			var(--v-gray_10-base);
		min-height: 100vh;
		padding: 28px;
	}

	.outer-wrapper-in-frame {
	}

	.main-wrapper {
		border: 1px solid var(--v-gray_30-base);
		border-radius: 24px;
		max-width: 900px;
		margin: 0;
		padding: 32px;
		height: fit-content;
		background-color: var(--v-white-base);
		box-shadow: 0 24px 70px rgba(22, 24, 35, 0.09);
	}

	.main-wrapper-in-frame {
		padding: 0;
	}

	.form-logo-row {
		text-align: left;
		margin-bottom: 8px;
	}

	.form-logo {
		display: block;
		max-height: 88px;
		max-width: 240px;
		object-fit: contain;
	}

	.form-fields {
		padding: 0 8px;
	}

	.form-footer {
		padding: 18px 24px 0;
		text-align: left;
	}

	.form-submit {
		min-width: 154px !important;
		min-height: 46px !important;
		border-radius: 14px !important;
	}

	.form-recaptcha {
		max-width: 520px;
		margin-top: 24px;
		font-size: 10px;
		line-height: 1.55;
	}

	::v-deep {
		.v-input__slot {
			border-radius: 13px !important;
		}

		.v-text-field--outlined fieldset {
			border-color: var(--v-gray_40-base);
		}

		.v-text-field--outlined.v-input--is-focused fieldset {
			border-color: var(--background-color) !important;
		}

		.v-label {
			color: var(--v-gray_70-base);
		}
	}

	@media (max-width: 600px) {
		.outer-wrapper {
			padding: 0;
			align-items: stretch !important;
		}

		.main-wrapper {
			min-height: 100vh;
			max-width: none;
			padding: 20px 12px;
			border: 0;
			border-radius: 0;
			box-shadow: none;
		}

		.form-fields {
			padding: 0;
		}

		.form-footer {
			padding: 16px 12px 0;
		}

		.form-submit {
			width: 100% !important;
		}
	}
</style>
